import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import toast from '../utils/toastManager';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function WechatBindCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const handleWechatBindCallback = useCallback(async (code, state) => {
    try {
      console.log('WechatBindCallback: 开始处理绑定回调', { code, state });
      
      // 使用GET请求调用后端接口，state就是userId
      const response = await fetch(`${API_BASE_URL}/auth/wechat-bind-callback?code=${code}&state=${state}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
        }
      });

      console.log('WechatBindCallback: 收到响应状态:', response.status);
      const data = await response.json();
      console.log('WechatBindCallback: 响应数据:', data);
      
      if (data.success) {
        console.log('WechatBindCallback: 绑定成功');
        toast.success('微信绑定成功！');
        
        // 跳转回账号管理页面
        setTimeout(() => {
          navigate('/account-settings');
        }, 1500);
      } else {
        console.log('WechatBindCallback: 绑定失败:', data.message || data.error);
        throw new Error(data.message || data.error || '微信绑定失败');
      }
    } catch (error) {
      console.error('WechatBindCallback: 微信绑定回调处理失败:', error);
      setError('微信绑定失败：' + (error.message || '未知错误'));
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    console.log('WechatBindCallback: 组件开始初始化');
    
    // 检查是否有code参数
    const code = searchParams.get('code');
    const state = searchParams.get('state'); // state就是userId
    
    if (!code || !state) {
      setError('授权失败：缺少必要参数');
      setLoading(false);
      return;
    }
    
    console.log('WechatBindCallback: 检测到授权回调参数', { code, state });
    
    // 处理微信绑定回调
    handleWechatBindCallback(code, state);
  }, [searchParams, handleWechatBindCallback]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f5f7fa'
      }}>
        <div style={{
          width: 40,
          height: 40,
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #1890ff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ marginTop: 16, color: '#666' }}>正在处理微信绑定...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: '#f5f7fa'
      }}>
        <div style={{ color: 'red', fontSize: '18px', marginBottom: '16px' }}>
          {error}
        </div>
        <button 
          onClick={() => navigate('/account-settings')}
          style={{
            padding: '8px 16px',
            background: '#1890ff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          返回账号管理
        </button>
      </div>
    );
  }

  return null;
} 